import { createMarkStore } from './mark-store'
import type { StagedAction } from './types'

const ARCHIVE_MARK_TTL_MS = 5 * 60 * 1000

/**
 * The list endpoint reads through a Hyperdrive binding that caches SELECTs and
 * does not invalidate them on write, so the refetch right after an archive or
 * restore can answer from before the write. Without this, restoring an action
 * flipped it back to archived until the cache aged out.
 */
const store = createMarkStore<{ archivedAt: string | null }, StagedAction>({
  ttlMs: ARCHIVE_MARK_TTL_MS,
  // Compare presence, not the timestamp: the server's own archivedAt is the
  // one to keep once it agrees the row is archived.
  isStale: (mark, row) => (row.archivedAt == null) !== (mark.archivedAt == null),
  pin: (mark, row) => ({ ...row, archivedAt: mark.archivedAt }),
})

export function rememberArchiveState(id: string, archivedAt: string | null): void {
  store.remember(id, { archivedAt })
}

/** Drop the mark after a failed archive/unarchive rolls the row back. */
export const forgetArchiveState = store.forget
export const clearArchiveMarks = store.clear
export const reconcileArchiveMarks = store.reconcile
